// ─── data.js ──────────────────────────────────────────────────────────────────
// Data-verwerking: filtert aanvragen per jaar en berekent statistieken.
// Wijzig hier bij aanpassingen aan berekeningen of nieuwe KPI's.

import { MAANDEN_K, isOnderweg } from './helpers.js';

function verwerkData(aanvragen, jaar, vergelijkJaar) {
  const lijst    = aanvragen.filter(a=>new Date(a.Datum||0).getFullYear()===jaar);
  const vorig    = vergelijkJaar ? aanvragen.filter(a=>new Date(a.Datum||0).getFullYear()===vergelijkJaar) : [];

  const kostenM  = Array(12).fill(0), volM = Array(12).fill(0), gewM = Array(12).fill(0);
  const landK={}, routeK={}, goedMap={};
  let totK=0, totGew=0, totColli=0, totDoorloop=0, nDoorloop=0;

  lijst.forEach(a=>{
    const mnd = new Date(a.Datum||0).getMonth();
    const b   = parseFloat(a.Factuur)||parseFloat(a.KlantPrijs)||0;
    kostenM[mnd]+=b; volM[mnd]++; totK+=b;
    [1,2,3,4,5].forEach(n=>{
      const g=parseFloat(a[`Goed${n}_Gewicht`])||0;
      const c=parseInt(a[`Goed${n}_Aantal`])||0;
      gewM[mnd]+=g; totGew+=g; totColli+=c;
      const s=a[`Goed${n}_Omschrijving`]||a[`Goed${n}_Soort`]||''; if(s) goedMap[s]=(goedMap[s]||0)+1;
    });
    const land=a.LosLand||''; if(land) landK[land]=(landK[land]||0)+1;
    const r=`${a.LaadPlaats||a.LaadLand||'?'} → ${a.LosPlaats||a.LosLand||'?'}`; routeK[r]=(routeK[r]||0)+1;
    if(a.LaadDatum&&a.LosDatum){
      const d=Math.round((new Date(a.LosDatum)-new Date(a.LaadDatum))/(864e5));
      if(d>0&&d<60){totDoorloop+=d;nDoorloop++;}
    }
  });

  const vorigK = vorig.reduce((s,a)=>s+(parseFloat(a.Factuur)||parseFloat(a.KlantPrijs)||0),0);

  return {
    lijst, vorig, totK, vorigK, totGew, totColli,
    gemK: lijst.length>0?totK/lijst.length:0,
    gemDoorloop: nDoorloop>0?Math.round(totDoorloop/nDoorloop):null,
    kostenM, volM, gewM,
    topLanden: Object.entries(landK).sort((a,b)=>b[1]-a[1]).slice(0,6).map(([l,v])=>({l,v})),
    topRoutes: Object.entries(routeK).sort((a,b)=>b[1]-a[1]).slice(0,6).map(([l,v])=>({l,v})),
    topGoed:   Object.entries(goedMap).sort((a,b)=>b[1]-a[1]).slice(0,6).map(([l,v])=>({l,v})),
  };
}

export { verwerkData };
